module.exports = __webpack_public_path__ + "assets/qixi.74ba7070.svg";